module.exports = __webpack_public_path__ + "img/header-engagementRingsCordial.9462ef1.jpg";